import React, {useState} from 'react';
import { data } from './data';
const Birthday = () => {
    var today = new Date(),
    date=today.getDate()+ '/' + (today.getMonth()+1);
    
    //hooks
    const [people, setPeople] = useState(data);
    
    //remove person
    const removeItem = (id) => {
        let newPeople= people.filter((person)=>person.id!==id)
        setPeople(newPeople);
    }

    const currentAge = (year) => {
        var todayYear=today.getFullYear()
        var newAge=todayYear-year
        return newAge
    }

    return (
        <>
        {people.filter((person)=>person.birthdate===date).map((person) => {
            const {id, name, year} = person;
            
            return (
                <section >
                    <div key={id} className='item' id="items">
                        <span><h3>{name}</h3></span>
                        <span ><h3>{currentAge(year)}</h3></span>
                        <span><button className="btn" onClick={()=> removeItem(id)}>clear item</button></span>
                    </div>
                </section>
            )   
      
    }) }
     
        <section>
          <div className='item' id="items">
            <button className="btn cnt" onClick={()=> setPeople([])}>clear all</button>
        </div>
        </section>
        
        
        </>
    );
}

export default Birthday
